<template>
    <label class="opui-form-label-top"></label>

    <div class="opui-row">
        <div class="opui-col">
            <div class="opfl-event-type-picker">
                <a href="#" @click.prevent="setEventType('action')">
                    <span class="opfl-event-icon"><img width="42" height="42" :src="this.imgUrl('action.svg')" alt="Action" /></span>
                    <strong class="opfl-event-type">{{ $e('Action') }}</strong>
                    <small class="opfl-event-desc">{{ $e('Run an action on the data from the trigger event') }}</small>
                </a>

                <a href="#" @click.prevent="setEventType('delay')">
                    <span class="opfl-event-icon"><img width="42" height="42" :src="this.imgUrl('timer.svg')" alt="Delay" /></span>
                    <strong class="opfl-event-type">{{ $e('Delay') }}</strong>
                    <small class="opfl-event-desc">{{ $e('Pause workflow for a certain amount of time') }}</small>
                </a>

                <a href="#" @click.prevent="setEventType('filter')">
                    <span class="opfl-event-icon"><i class="opui-fa opui-fa-filter" alt="Filter"></i></span>
                    <strong class="opfl-event-type">{{ $e('Filter') }}</strong>
                    <small class="opfl-event-desc">{{ $e('Filter data from your trigger event') }}</small>
                </a>
            </div>

            <p class="opui-text-center">
                {{ $e('Choose the next event in your workflow.') }}
                <a href="https://optimizelink.com" target="_blank">{{ $e('Learn more.') }}</a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item:     { type: Object, required: true },
        workflow: { type: Object, required: true },
    },
    methods: {
        setEventType(type) {
            this.item.type = type

            // Also update some default settings
            if (type === 'delay') {
                this.item.action = 'delay'
                this.item.settings = {value: 1, unit: 'i'}
            } else if (type === 'filter') {
                this.item.action = 'filter'
                this.item.rows   = []
            } else {
                this.item.settings = {}
            }
        }
    }
}
</script>
